module.exports = __webpack_public_path__ + "static/img/equip-1.6cac0f6c.png";